import { ClearPayMessageUI } from "./ClearPayMessageUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { ensureIsActive } from "@/utils/product/ensureIsActive";
import { CreditIllustration } from "@/types/cobeTypes";

export function ClearPayMessage({
  product,
  runtimeConfig,
  creditOffersV2,
  flags,
}: Pick<
  StandardProps,
  "product" | "runtimeConfig" | "creditOffersV2" | "flags"
>) {
  const {
    variant: {
      aliases: { skuId },
      price,
    },
    isSelected,
    variant,
  } = useVariant(product);

  const showClearPayMessage = flags.showClearPayMessage.value === true;

  const activeProduct = ensureIsActive(product);

  if (!activeProduct || !isSelected) {
    return false;
  }

  const eligibleForClearpay = creditOffersV2?.find(
    ({ skuId, creditIllustrations }) => {
      const hasClearpayOffer = creditIllustrations.find(
        (illustration: CreditIllustration) =>
          illustration.creditProvider.toLowerCase() === "clearpay",
      );
      return skuId === variant.aliases.skuId && hasClearpayOffer;
    },
  );

  if (!eligibleForClearpay || !showClearPayMessage) return null;

  return (
    <ClearPayMessageUI
      runtimeConfig={runtimeConfig}
      skuId={skuId}
      currentPrice={price?.value}
      isSelected={isSelected}
    />
  );
}
